module.exports = __webpack_public_path__ + "img/xiajia@2x.eeb1461f.png";